var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step2" }, [
    _c(
      "div",
      { staticClass: "switch-con" },
      [
        _c(
          "CSwitch",
          {
            attrs: { color: "#4caf50" },
            model: {
              value: _vm.inputVisible,
              callback: function($$v) {
                _vm.inputVisible = $$v
              },
              expression: "inputVisible"
            }
          },
          [_vm._v("Is a PO required?")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.inputVisible
      ? _c("div", { staticClass: "input-con" }, [
          _c("table", [
            _c("tr", [
              _c("td", [_vm._v("PO Number:")]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData,
                      expression: "inputData"
                    }
                  ],
                  staticClass: "input",
                  attrs: { id: "input", type: "text" },
                  domProps: { value: _vm.inputData },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputData = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Delivery Date:")]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputPoDate,
                      expression: "inputPoDate"
                    }
                  ],
                  staticClass: "input",
                  attrs: { id: "input", type: "date" },
                  domProps: { value: _vm.inputPoDate },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputPoDate = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-con" },
      [
        _c("CButton", {
          attrs: { color: "green", text: "Next" },
          on: { click: _vm.onNextClick }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "orange", text: "Back" },
              on: { click: _vm.onBack }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "red", text: "Cancel" },
              on: { click: _vm.onCancel }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }